import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { useUser } from '../../../contexts/userContext';
import { useCard } from '../../../contexts/cardContext';
import api from '../../../services/api';
import Header from '../../Header';
import { MdKeyboardArrowDown, MdKeyboardArrowUp, MdDownload } from 'react-icons/md';
import Logo from '../../../assets/logo-suite-flow.ico';
import './style.css';
import PreviewCard from '../../PreviewCard';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function BazzeBrokerPage() {


    const [dataInicial, setDataInicial] = useState('');
    const [dataFinal, setDataFinal] = useState('');
    const [cards, setCards] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expandedUsers, setExpandedUsers] = useState({});
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [password, setPassword] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const { user, listAllUsers, getAccessLevel } = useUser();
    const [selectedCard, setSelectedCard] = useState(null);

    // Estados para filtro de entidades
    const [selectedEntities, setSelectedEntities] = useState([]);
    const [openEntityModal, setOpenEntityModal] = useState(false);
    const [searchEntidades, setSearchEntidades] = useState('');
    const [entitiesInitialized, setEntitiesInitialized] = useState(false);
    
    // Estados para filtro por estado
    const [selectedStates, setSelectedStates] = useState([]);
    const [searchStates, setSearchStates] = useState('');

    // Função para obter todos os estados únicos das entidades
    const getUniqueStates = () => {
        const states = listAllUsers
            .map(user => user.state)
            .filter(state => state && state.trim() !== '')
            .filter((state, index, arr) => arr.indexOf(state) === index)
            .sort();
        return states;
    };

    // Função para filtrar entidades por estado
    const getFilteredUsers = () => {
        let filtered = listAllUsers;

        // Filtrar por estados selecionados
        if (selectedStates.length > 0) {
            filtered = filtered.filter(user => 
                selectedStates.includes(user.state)
            );
        }

        // Filtrar por termo de busca
        if (searchEntidades) {
            filtered = filtered.filter(user =>
                user.username.toLowerCase().includes(searchEntidades.toLowerCase())
            );
        }

        return filtered;
    };

    // Inicializar selectedEntities com todos os usuários quando listAllUsers estiver disponível
    useEffect(() => {
        if (listAllUsers.length > 0 && !entitiesInitialized) {
            setSelectedEntities(listAllUsers.map(user => user.id));
            setEntitiesInitialized(true);
        }
    }, [listAllUsers, entitiesInitialized]);

    const handlePasswordSubmit = (e) => {
        e.preventDefault();
        if (password === 'bazze123') {
            setIsAuthenticated(true);
        } else {
            alert('Senha incorreta!');
            setPassword('');
        }
    };

    // Função para obter informações do usuário pelo entity_id
    const getUserInfo = (entityId) => {
        const userInfo = listAllUsers.find(user => user.id === entityId);
        return userInfo || null;
    };

    // Função para filtrar cards pelo nome do usuário e entidades selecionadas
    const filterCardsByUser = (groupedCards) => {
        let filtered = groupedCards;

        // Filtro por termo de busca
        if (searchTerm) {
            filtered = filtered.filter(group =>
                group.userInfo?.username?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        // Filtro por entidades selecionadas
        // Se selectedEntities estiver vazio ou tiver todos os usuários, mostra todos
        // Caso contrário, filtra apenas pelos selecionados
        if (selectedEntities.length > 0 && selectedEntities.length < listAllUsers.length) {
            filtered = filtered.filter(group =>
                selectedEntities.includes(group.entityId)
            );
        }

        return filtered;
    };

    // Função para agrupar cards por entity_id e calcular total de valor_lead
    const groupCardsByEntity = (cards) => {
        const grouped = cards.reduce((acc, card) => {
            const entityId = card.entity_id;
            if (!acc[entityId]) {
                const userInfo = getUserInfo(entityId);
                acc[entityId] = {
                    entityId,
                    userInfo,
                    totalValorLead: 0,
                    totalLeads: 0,
                    cards: []
                };
            }
            acc[entityId].totalValorLead += card.valor_lead || 0;
            acc[entityId].totalLeads += 1;
            acc[entityId].cards.push(card);
            return acc;
        }, {});

        return Object.values(grouped);
    };

    const handleBuscar = async () => {
        if (!dataInicial || !dataFinal) return;

        try {
            setLoading(true);
            
            // Criar datas considerando fuso horário de São Paulo
            const dataInicialObj = new Date(dataInicial + 'T00:00:00-03:00'); // UTC-3 (São Paulo)
            const dataFinalObj = new Date(dataFinal + 'T23:59:59-03:00'); // UTC-3 (São Paulo)

            let response;

            if (getAccessLevel('adm')) {
                response = await api.get(`/card/find-by-temperatura/${user?.empresa_id}`, {
                    params: {
                        dataInicial: format(dataInicialObj, 'yyyy-MM-dd'),
                        dataFinal: format(dataFinalObj, 'yyyy-MM-dd')
                    }
                });
            } else {
                response = await api.get(`/card/find-by-temperatura/user/${user?.empresa_id}/${user?.id}`, {
                    params: {
                        dataInicial: format(dataInicialObj, 'yyyy-MM-dd'),
                        dataFinal: format(dataFinalObj, 'yyyy-MM-dd')
                    }
                });
            }

            setCards(response.data.filter(card => (card.cost_value || 0) > 0));

        } catch (error) {
            console.error('Erro ao buscar cards:', error);
            alert('Erro ao buscar cards. Por favor, tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    const toggleUserExpansion = (entityId) => {
        setExpandedUsers(prev => {
            const newSet = { ...prev };
            if (newSet[entityId]) {
                delete newSet[entityId];
            } else {
                newSet[entityId] = true;
            }
            return newSet;
        });
    };

    const [filtroStatus, setFiltroStatus] = useState(null);

    const groupedCards = groupCardsByEntity(cards);
    const groupedFilteredByUser = filterCardsByUser(groupedCards);
    
    const cardsFiltrados = groupedFilteredByUser
        .flatMap(group => group.cards)
        .filter(card => {
            if (!filtroStatus) return true;
            if (filtroStatus === 'Oportunidade') return card.status !== 'Vendido' && card.status !== 'Perdido';
            return card.status === filtroStatus;
        });
    
    const filteredGroupedCards = groupCardsByEntity(cardsFiltrados);


    const handleCardClick = (card) => {
        setSelectedCard(card);
    };

    const handleClosePreview = () => {
        setSelectedCard(null);
    };

    const exportFilteredToExcel = async () => {
        try {
            // Usar os dados filtrados que estão sendo exibidos na tela
            const dataToExport = cardsFiltrados;
            
            if (dataToExport.length === 0) {
                alert('Nenhum dado para exportar. Aplique filtros primeiro.');
                return;
            }

            // Criar workbook
            const workbook = new ExcelJS.Workbook();
            workbook.creator = 'SyncsCRM';
            workbook.created = new Date();

            // Criar worksheet
            const worksheet = workbook.addWorksheet('BazzeBroker - Dados Filtrados', {
                pageSetup: { paperSize: 9, orientation: 'landscape' }
            });

            // Definir cabeçalhos
            const headers = [
                'Cliente', 'Participante', 'Etiqueta', 'Temperatura', 'Valor Lead', 
                'Valor Card', 'Status', 'Data Atualização', 'Usuário Responsável'
            ];

            // Adicionar cabeçalhos
            const headerRow = worksheet.addRow(headers);

            // Formatação do cabeçalho
            headerRow.eachCell((cell, colNumber) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF4472C4' }
                };
                cell.font = {
                    name: 'Calibri',
                    size: 11,
                    bold: true,
                    color: { argb: 'FFFFFFFF' }
                };
                cell.alignment = {
                    horizontal: 'center',
                    vertical: 'middle',
                    wrapText: true
                };
                cell.border = {
                    top: { style: 'medium', color: { argb: 'FF000000' } },
                    left: { style: 'thin', color: { argb: 'FF000000' } },
                    bottom: { style: 'medium', color: { argb: 'FF000000' } },
                    right: { style: 'thin', color: { argb: 'FF000000' } }
                };
            });

            // Definir larguras das colunas
            const columnWidths = [30, 25, 20, 15, 15, 15, 15, 20, 25];
            columnWidths.forEach((width, index) => {
                worksheet.getColumn(index + 1).width = width;
            });

            // Adicionar dados
            let totalValorLead = 0;
            let totalValorCard = 0;
            dataToExport.forEach((item) => {
                const userInfo = getUserInfo(item.entity_id);
                const valorLead = item.valor_lead || 0;
                const valorCard = Number(item.cost_value) || 0;
                totalValorLead += valorLead;
                totalValorCard += valorCard;
                
                const rowData = [
                    item.name || '',
                    item.participante_name || '',
                    item.etiqueta_name || '',
                    item.temperatura_card || '',
                    valorLead.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                    valorCard.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                    item.status || '',
                    item.temperatura_updated_at ? format(new Date(item.temperatura_updated_at), 'dd/MM/yyyy HH:mm') : '',
                    userInfo ? userInfo.username : 'Usuário não encontrado'
                ];

                const dataRow = worksheet.addRow(rowData);
                dataRow.height = 25;

                // Formatação das células de dados
                dataRow.eachCell((cell, colNumber) => {
                    cell.font = {
                        name: 'Calibri',
                        size: 10,
                        color: { argb: 'FF000000' }
                    };
                    cell.alignment = {
                        horizontal: 'center',
                        vertical: 'middle',
                        wrapText: true
                    };
                    cell.border = {
                        top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                        left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                        bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                        right: { style: 'thin', color: { argb: 'FFCCCCCC' } }
                    };
                });
            });

            // Configurar filtros
            worksheet.autoFilter = {
                from: 'A1',
                to: `${String.fromCharCode(65 + headers.length - 1)}${dataToExport.length + 1}`
            };

            // Congelar primeira linha
            worksheet.views = [
                { state: 'frozen', ySplit: 1 }
            ];

            // Adicionar linha de resumo
            const resumoRow = worksheet.addRow([
                '📊 RESUMO',
                '',
                '',
                '',
                `Total Valor Lead: ${totalValorLead.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`,
                `Total Valor Card: ${totalValorCard.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`,
                `Total: ${dataToExport.length} registros`,
                '',
                ''
            ]);

            // Formatação da linha de resumo
            resumoRow.eachCell((cell, colNumber) => {
                if (colNumber === 1 || colNumber === 5 || colNumber === 6 || colNumber === 7) {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FF2F5F8F' }
                    };
                    cell.font = {
                        name: 'Calibri',
                        size: 12,
                        bold: true,
                        color: { argb: 'FFFFFFFF' }
                    };
                }
                cell.alignment = {
                    horizontal: 'center',
                    vertical: 'middle',
                    wrapText: true
                };
            });

            // Gerar arquivo
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            // Nome do arquivo com data e hora
            const now = new Date();
            const timestamp = now.toLocaleString('pt-BR').replace(/[/:]/g, '-').replace(/,/g, '');
            const fileName = `BazzeBroker_Filtrado_${timestamp}.xlsx`;

            saveAs(blob, fileName);

            alert(`Excel exportado com sucesso! ${dataToExport.length} registros incluídos.`);

        } catch (error) {
            console.error('Erro ao exportar Excel:', error);
            alert('Erro ao gerar planilha. Tente novamente.');
        }
    };




    const calcularTotaisPorStatus = (cardsParaCalcular) => {
        let totalCostTodos = 0;
        let totalLeadTodos = 0;

        let totalCostVendidos = 0;
        let totalLeadVendidos = 0;

        let totalCostPerdidos = 0;
        let totalLeadPerdidos = 0;

        let totalCostAbertos = 0;
        let totalLeadAbertos = 0;

        cardsParaCalcular.forEach(card => {
            const cost = parseFloat(card.cost_value) || 0;
            const lead = card.valor_lead || 0;

            totalCostTodos += cost;
            totalLeadTodos += lead;

            if (card.status === 'Vendido') {
                totalCostVendidos += cost;
                totalLeadVendidos += lead;
            } else if (card.status === 'Perdido') {
                totalCostPerdidos += cost;
                totalLeadPerdidos += lead;
            } else {
                totalCostAbertos += cost;
                totalLeadAbertos += lead;
            }
        });

        return {
            totalCostTodos,
            totalLeadTodos,
            totalCostVendidos,
            totalLeadVendidos,
            totalCostPerdidos,
            totalLeadPerdidos,
            totalCostAbertos,
            totalLeadAbertos
        };
    };




    const calcularTotalGeralDeReceita = () => {
        return cards.reduce((total, card) => {
            const valor = parseFloat(String(card.cost_value).replace(/[^\d.-]/g, ''));
            return !isNaN(valor) ? total + valor : total;
        }, 0);
    };




    const calcularCacEticketMedio = (cardsParaCalcular) => {
        let totalCustoAquisicao = 0;
        let totalReceita = 0;
        let quantidadeVendidos = 0;

        cardsParaCalcular.forEach(card => {
            if (card.status === 'Vendido') {
                totalCustoAquisicao += card.valor_lead || 0;

                const receita = parseFloat(String(card.cost_value).replace(/[^\d.-]/g, ''));
                if (!isNaN(receita)) {
                    totalReceita += receita;
                }

                quantidadeVendidos++;
            }
        });

        return {
            cacMedio: quantidadeVendidos > 0 ? totalCustoAquisicao / quantidadeVendidos : 0,
            ticketMedio: quantidadeVendidos > 0 ? totalReceita / quantidadeVendidos : 0,
            quantidadeVendidos,
            totalCustoAquisicao,
            totalReceita
        };
    };




    return (
        <div className="proken-bazze-broker-container-2">
            {!isAuthenticated && (
                <div className="password-overlay">
                    <div className="password-container">
                        <h2>Acesso Restrito</h2>
                        <form onSubmit={handlePasswordSubmit}>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Digite a senha"
                                required
                                className="proken-input-senha"
                            />
                            <button type="submit">Acessar</button>
                        </form>
                    </div>
                </div>
            )}
            <Header />

            <div className='proken-bazze-broker-container'>
                <div className="proken-bazze-broker-header">
                    <h1 className="proken-bazze-broker-title">

                    </h1>
                </div>
                <div className="proken-bazze-broker-content">
                    <div className="proken-content-header">


                        <div className="proken-bazze-broker-filters">
                            <div className="proken-filter-group">
                                <label className="proken-filter-label">
                                    Data Inicial
                                </label>
                                <input
                                    type="date"
                                    value={dataInicial}
                                    onChange={(e) => setDataInicial(e.target.value)}
                                    className="proken-input"
                                />
                            </div>
                            <div className="proken-filter-group">
                                <label className="proken-filter-label">
                                    Data Final
                                </label>
                                <input
                                    type="date"
                                    value={dataFinal}
                                    onChange={(e) => setDataFinal(e.target.value)}
                                    className="proken-input"
                                />
                            </div>
                            <div className="proken-filter-group">
                                <label className="proken-filter-label">
                                    Buscar Usuário
                                </label>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    placeholder="Digite o nome do usuário"
                                    className="proken-input"
                                    style={{ minHeight: '43px', minWidth: '300px' }}
                                />
                            </div>
                            <button
                                onClick={() => setOpenEntityModal(true)}
                                className="proken-search-button"
                                style={{ backgroundColor: '#6c5ce7', minWidth: '140px' }}
                            >
                                Entidades {selectedEntities.length > 0 && `(${selectedEntities.length})`}
                            </button>
                            <button
                                onClick={handleBuscar}
                                disabled={loading}
                                className="proken-search-button"
                            >
                                {loading ? 'Buscando...' : 'Buscar'}
                            </button>
                            <button
                                onClick={exportFilteredToExcel}
                                disabled={cardsFiltrados.length === 0}
                                className="proken-search-button"
                                style={{ backgroundColor: '#28a745', minWidth: '140px' }}
                                title="Exportar dados filtrados para Excel"
                            >
                                <MdDownload size={16} style={{ marginRight: '5px' }} />
                                Exportar Excel
                            </button>
                        </div>









                    </div>

                    <div className="proken-bazze-broker-content-list">


                        {cards.length > 0 && (() => {
                            const totais = calcularTotaisPorStatus(cardsFiltrados);
                            const { cacMedio, ticketMedio } = calcularCacEticketMedio(cardsFiltrados);
                            const totalCards = cardsFiltrados.length;
                            const totalVendidos = cardsFiltrados.filter(card => card.status === 'Vendido').length;
                            const totalPerdidos = cardsFiltrados.filter(card => card.status === 'Perdido').length;
                            const totalOportunidades = totalCards - totalVendidos - totalPerdidos;



                            return (

                                <div className="proken-cards-analytics">
                                    <div className={`proken-card-analytics ${filtroStatus === null ? 'ativo' : ''}`} onClick={() => setFiltroStatus(null)}>
                                        <h4>Total Geral</h4>
                                        <p>Total de cards: {totalCards}</p>
                                        <p>Total em Leads: {totais.totalCostTodos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                        <p>Custo de aquisições: {totais.totalLeadTodos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                    </div>

                                    <div className={`proken-card-analytics vendido ${filtroStatus === 'Vendido' ? 'ativo' : ''}`} onClick={() => setFiltroStatus('Vendido')}>
                                        <h4>Vendidos</h4>
                                        <p>Total de cards: {totalVendidos}</p>
                                        <p>Total em Leads: {totais.totalCostVendidos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                        <p>Custo de aquisições: {totais.totalLeadVendidos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                    </div>

                                    <div className={`proken-card-analytics perdido ${filtroStatus === 'Perdido' ? 'ativo' : ''}`} onClick={() => setFiltroStatus('Perdido')}>
                                        <h4>Perdidos</h4>
                                        <p>Total de cards: {totalPerdidos}</p>
                                        <p>Total em Leads: {totais.totalCostPerdidos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                        <p>Custo de aquisições: {totais.totalLeadPerdidos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                    </div>

                                    <div className={`proken-card-analytics aberto ${filtroStatus === 'Oportunidade' ? 'ativo' : ''}`} onClick={() => setFiltroStatus('Oportunidade')}>
                                        <h4>Oportunidades</h4>
                                        <p>Total de cards: {totalOportunidades}</p>
                                        <p>Receita em potencial: {totais.totalCostAbertos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                        <p>Custo de aquisições: {totais.totalLeadAbertos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                    </div>

                                    <div className="proken-card-analytics resumo" onClick={() => setFiltroStatus('Oportunidade')}>
                                        <h4>Métricas de Vendas</h4>
                                        <p>CAC Médio: {cacMedio.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                        <p>Ticket Médio: {ticketMedio.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                    </div>
                                </div>

                            );
                        })()}






                        {filteredGroupedCards.length > 0 ? (
                            <div className="proken-user-groups-list">
                                {filteredGroupedCards.map((group) => (
                                    <div key={group.entityId} className="proken-user-group">
                                        <div
                                            className="proken-user-group-header"
                                            onClick={() => toggleUserExpansion(group.entityId)}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            <div className="proken-user-group-header-content">
                                                <div className="proken-user-group-title">
                                                    <img
                                                        className='proken-user-group-avatar'
                                                        src={group.userInfo && group.userInfo.avatar ?
                                                            (group.userInfo.avatar.includes('syncs-avatar') ?
                                                                require(`../../../assets/avatares/${group.userInfo.avatar}`)
                                                                : group.userInfo.avatar)
                                                            : Logo}
                                                        alt={`${group.userInfo ? group.userInfo.username : 'Usuário Desconhecido'}'s avatar`}
                                                    />
                                                    <div className="flex items-center justify-between w-full">
                                                        <h2 className="proken-user-name">
                                                            {group.userInfo ? group.userInfo.username : 'Usuário Desconhecido'}
                                                        </h2>
                                                        <div className="proken-user-totals">
                                                            <span className="proken-total-valor-lead">
                                                                Valor: {group.totalValorLead.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                            </span>
                                                            <span className="proken-total-leads" style={{ marginLeft: '18px' }}>
                                                                Leads: {group.totalLeads}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {expandedUsers[group.entityId] ? (
                                                        <MdKeyboardArrowUp className="proken-expand-icon" />
                                                    ) : (
                                                        <MdKeyboardArrowDown className="proken-expand-icon" />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        {expandedUsers[group.entityId] && (
                                            <div className="proken-cards-list">
                                                <ul>
                                                    {group.cards.map((card) => (
                                                        <li key={card.id} className="proken-card-item">
                                                            <div className="proken-card-content">
                                                                <div className="proken-card-info">
                                                                    <h3 className="proken-card-title">{card.name}</h3>
                                                                    <p className="proken-card-participant">{card.participante_name}</p>
                                                                </div>
                                                                <div className="proken-card-meta">
                                                                    <span
                                                                        className="proken-card-tag"
                                                                        style={{ backgroundColor: card.etiqueta_color + '20', color: card.etiqueta_color }}
                                                                    >
                                                                        {card.etiqueta_name}
                                                                    </span>
                                                                    <div className="proken-card-temperature">
                                                                        <p className="proken-temperature-value">
                                                                            Temperatura: {card.temperatura_card}
                                                                        </p>
                                                                        <p className="proken-valor-lead">
                                                                            Valor Lead: {(card.valor_lead || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                                        </p>
                                                                        <p className="proken-valor-lead-cost">
                                                                            Valor do Card: {(Number(card.cost_value) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                                        </p>
                                                                        <p className="proken-temperature-date">
                                                                            Atualizado em: {format(new Date(card.temperatura_updated_at), 'dd/MM/yyyy HH:mm')}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="proken-card-actions">
                                                                <button
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleCardClick(card);
                                                                    }}
                                                                >
                                                                    Ver Detalhes
                                                                </button>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="proken-empty-state">
                                {dataInicial && dataFinal ? 'Nenhum card encontrado' : 'Selecione um período para buscar os cards'}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {selectedCard && (
                <div className="preview-card-modal">
                    <div className="preview-card-overlay" onClick={handleClosePreview}>
                        <div className="preview-card-content" onClick={e => e.stopPropagation()}>
                            <button style={{ display: 'none' }} className="close-button" onClick={handleClosePreview}>X</button>
                            <PreviewCard cardData={selectedCard} />
                        </div>
                    </div>
                </div>
            )}

            {openEntityModal && (
                <div className="modal-controles">
                    <div className="bazze-modal-controles-content">
                        <button className="btn-close" onClick={() => setOpenEntityModal(false)}>✖️</button>
                        <h3>Selecionar Entidades</h3>
                        <div className="bazze-controles-list">
                            <div className="filters-side-by-side">
                                {/* Seção de Filtro por Estado */}
                                <div className="filter-section">
                                    <h4 style={{ marginBottom: '10px', color: '#333', fontSize: '14px' }}>
                                        📍 Filtrar por Estado
                                    </h4>
                                    <div className="modal-processos-actions">
                                        <button
                                            className="btn-action-select"
                                            onClick={() => setSelectedStates(getUniqueStates())}
                                        >
                                            <span className="icon">✔️</span>
                                            <span className="text">Marcar todos</span>
                                        </button>
                                        <button
                                            className="btn-action-select"
                                            onClick={() => setSelectedStates([])}
                                        >
                                            <span className="icon">❌</span>
                                            <span className="text">Desmarcar todos</span>
                                        </button>
                                    </div>
                                    <div className="search-modal-container">
                                        <input
                                            type="text"
                                            value={searchStates}
                                            onChange={(e) => setSearchStates(e.target.value)}
                                            placeholder="Buscar estados..."
                                            className="search-modal-input"
                                        />
                                    </div>
                                    <div className="states-list">
                                        {getUniqueStates()
                                            .filter(state => state.toLowerCase().includes(searchStates.toLowerCase()))
                                            .map((state) => (
                                                <label key={state} className="controle-option">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedStates.includes(state)}
                                                        onChange={() => {
                                                            if (selectedStates.includes(state)) {
                                                                setSelectedStates(selectedStates.filter(s => s !== state));
                                                            } else {
                                                                setSelectedStates([...selectedStates, state]);
                                                            }
                                                        }}
                                                    />
                                                    {state}
                                                </label>
                                            ))}
                                    </div>
                                </div>

                                {/* Seção de Busca de Entidades */}
                                <div className="filter-section">
                                    <h4 style={{ marginBottom: '10px', color: '#333', fontSize: '14px' }}>
                                        👥 Entidades {selectedStates.length > 0 && `(Filtradas por ${selectedStates.length} estado${selectedStates.length > 1 ? 's' : ''})`}
                                    </h4>
                                    <div className="modal-processos-actions">
                                        <button
                                            className="btn-action-select"
                                            onClick={() => setSelectedEntities(getFilteredUsers().map(user => user.id))}
                                        >
                                            <span className="icon">✔️</span>
                                            <span className="text">Marcar todos</span>
                                        </button>
                                        <button
                                            className="btn-action-select"
                                            onClick={() => setSelectedEntities([])}
                                        >
                                            <span className="icon">❌</span>
                                            <span className="text">Desmarcar todos</span>
                                        </button>
                                    </div>
                                    <div className="search-modal-container">
                                        <input
                                            type="text"
                                            value={searchEntidades}
                                            onChange={(e) => setSearchEntidades(e.target.value)}
                                            placeholder="Buscar entidades..."
                                            className="search-modal-input"
                                        />
                                    </div>
                                    <div className="processos-list">
                                        {getFilteredUsers().map((user) => (
                                            <label key={user.id} className="controle-option">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedEntities.includes(user.id)}
                                                    onChange={() => {
                                                        if (selectedEntities.includes(user.id)) {
                                                            setSelectedEntities(selectedEntities.filter(id => id !== user.id));
                                                        } else {
                                                            setSelectedEntities([...selectedEntities, user.id]);
                                                        }
                                                    }}
                                                />
                                                <span>{user.username}</span>
                                                {user.state && (
                                                    <span style={{ fontSize: '12px', color: '#666', marginLeft: '8px' }}>
                                                        ({user.state})
                                                    </span>
                                                )}
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-controles-footer">
                            <button
                                className="btn-programacao-producao"
                                onClick={() => { 
                                    setOpenEntityModal(false); 
                                    setSearchEntidades(''); 
                                    setSearchStates('');
                                }}
                            >
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default BazzeBrokerPage; 